var trackingEvent = require('src/interlock/no-ui/tracking/event');
var constant = require('src/interlock/no-ui/tracking/constant');

module.exports = {
    tool_select_car_reviews_and_road_tests: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_reviews_and_road_tests'),

    tool_select_car_reviews: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_reviews'),

    tool_select_tips_advice: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'tips_advice'),

    tool_select_long_term_road_tests: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'long-term_road_tests'),

    tool_select_car_videos: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_videos'),

    tool_select_dealer_ratings_and_reviews: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'dealer_ratings_and_reviews'),

    tool_select_maintenance: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'maintenance'),

    tool_select_new_cars: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'new_cars'),

    tool_select_calculators: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'calculators'),

    tool_select_car_loan_calculators: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_loan_calculators'),

    tool_select_car_finder: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_finder'),

    tool_select_compare_cars: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'compare_cars'),

    tool_select_find_a_dealer: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'find_a_dealer'),

    tool_select_get_monthly_payment: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'get_monthly_payment'),

    tool_select_incentives_rebates: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'incentives_rebates'),

    tool_select_true_cost_to_own: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'true_cost_to_own'),

    tool_select_used_cars: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'used_cars'),

    tool_select_appraise_your_car: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'appraise_your_car'),

    tool_select_certified_cars: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'certified_cars'),

    tool_select_selling_tips: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'selling_tips'),

    tool_select_configure_vehicle: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'configure_vehicle'),

    tool_select_car_news: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_news'),

    tool_select_automobile_forums: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'automobile_forums'),

    tool_select_car_dealerships: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_dealerships'),

    tool_select_car_financing: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_financing'),

    tool_select_car_leasing: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_leasing'),

    tool_select_buy_a_car: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'buy_a_car'),

    tool_select_sell_my_car: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'sell_my_car'),

    tool_select_car_valuation: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_valuation'),

    tool_select_research: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'research')
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/tracking/maps/common/tool.js
// module id = 87
// module chunks = 0 1 2 3 4 5 6 7 8 9 11 12 13 14